import { useState } from 'react'

import { dateToStr24HPad0DayOfWeek } from 'utils/convertFromLocalDate'
import { getAPI } from 'utils/getAPI'

import type { DlCsvDownloadCsvDataTypeGetRequest, DlXlsxDownloadXlsxDataTypeGetRequest } from 'api-client'

export const useFileDownload = () => {
  const [csvIsLoading, setCsvIsLoading] = useState(false)
  const [xlsxIsLoading, setXlsxIsLoading] = useState(false)

  const fetchCsvDownload = async (filename: string, searchParam: DlCsvDownloadCsvDataTypeGetRequest) => {
    setCsvIsLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.dlCsvDownloadCsvDataTypeGetRaw(searchParam)
      
      const blob = await response.raw.blob()
      const url = window.URL.createObjectURL(new Blob([blob], { type: blob.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${filename}_${dateToStr24HPad0DayOfWeek(new Date(), 'YYYYMMDDhhmmss')}`)
      document.body.appendChild(link)
      link.click()
      link.parentNode?.removeChild(link)
      
      return response
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      return undefined
    } finally {
      setCsvIsLoading(false)
    }
  }

  const fetchXlsxDownload = async (filename: string, searchParam: DlXlsxDownloadXlsxDataTypeGetRequest) => {
    setXlsxIsLoading(true)

    try {
      const api = await getAPI()
      if (!api) return undefined

      const response = await api.dlXlsxDownloadXlsxDataTypeGetRaw(searchParam)
      
      const blob = await response.raw.blob()
      const url = window.URL.createObjectURL(new Blob([blob], { type: blob.type }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${filename}_${dateToStr24HPad0DayOfWeek(new Date(), 'YYYYMMDDhhmmss')}`)
      document.body.appendChild(link)
      link.click()
      link.parentNode?.removeChild(link)
      
      return response
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      return undefined
    } finally {
      setXlsxIsLoading(false)
    }
  }

  return {
    fetchCsvDownload,
    csvIsLoading,

    fetchXlsxDownload,
    xlsxIsLoading,
  }
}
